import React from 'react';

const formatFileSize = (bytes) => {
  if (!bytes) return '';
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  if (bytes < 1024 * 1024 * 1024) return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  return (bytes / (1024 * 1024 * 1024)).toFixed(1) + ' GB';
};

const MediaInfoBar = ({ filename, fileSize, isDarkMode }) => {
  if (!filename) return null;
  
  const themeClass = isDarkMode ? 'dark' : 'light';
  
  return (
    <div className={`media-info-bar ${themeClass}`}>
      <span className="media-filename">{filename}</span>
      {fileSize && <span className="media-size">{formatFileSize(fileSize)}</span>}
    </div>
  );
};

export default MediaInfoBar;
